export const DailyListKeys = {
  todayListName: "today",
  yesterdayListName: "yesterday",
};
